import { useCallback } from "react";
import { API_HOST } from "../constants";
import type { TelegramUser } from "../types";

export const useProgressSave = (user: TelegramUser | null) => {
  const saveProgress = useCallback(
    async (taskId: number, status: "success" | "error", code?: string, error_msg?: string) => {
      if (!user) return;
      try {
        await fetch(`${API_HOST}/user/${user.id}/progress`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ task_id: taskId, status, code, error_msg }),
        });
      } catch (err) {
        console.error("Не удалось сохранить прогресс:", err);
      }
    },
    [user]
  );

  return { saveProgress };
};

